import { Check, Lock } from "lucide-react";
import { useT } from "@/i18n";
import { MISSIONS } from "@/components/appbuilder/missions";

export default function MissionMap({ done, active, onSelect }) {
  const { lang } = useT();
  return (
    <div className="pb-1">
      <div className="grid grid-cols-5 lg:grid-cols-10 gap-y-3 justify-items-center">
        {MISSIONS.map((m, i) => {
          const isDone = done.includes(m.id);
          const unlocked = i === 0 || done.includes(MISSIONS[i - 1].id);
          const Icon = m.icon;
          return (
            <div key={m.id} className="flex items-center justify-center w-full">
              <button
                type="button"
                disabled={!unlocked}
                onClick={() => onSelect(i)}
                className={`relative flex flex-col items-center w-16 sm:w-20 group ${unlocked ? "" : "opacity-50 cursor-not-allowed"}`}
                data-testid={`mission-node-${m.id}`}
                title={m[lang][0]}
              >
                <span className={`w-14 h-14 rounded-full border-4 ${active === i ? "border-yellow-300 scale-110" : "border-white"} ${isDone ? "bg-lime-400" : m.color} shadow-lg flex items-center justify-center transition-transform group-hover:scale-110`}>
                  {isDone ? <Check className="w-7 h-7 text-white" strokeWidth={3} /> : unlocked ? <Icon className="w-6 h-6 text-white" /> : <Lock className="w-5 h-5 text-white" />}
                </span>
                <span className="absolute -top-1 -right-0 bg-white text-blue-950 text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center shadow">{i + 1}</span>
                <span className="mt-1 text-[11px] font-bold text-blue-950 text-center leading-tight h-7">{m[lang][0]}</span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
